import {
  AirtimeCarrierModel,
  AirTimeSupplierModel,
} from "features/airTimeManagement/data/model/detail/AirtimeManagementDetailResponseModel";
import { DataFormat } from "utils/format/DataFormat";

export class AirtimeDetailEntity {
  name?: string;
  code?: string;
  amount?: string;
  status?: number;
  type?: number;
  description?: string;
  config?: string;
  order?: number;
  createAt?: string;
  userFullName?: string;
  carrier?: AirtimeCarrierModel;
  AirTimeSupplier?: AirTimeSupplierModel[];

  constructor(data?: Partial<AirtimeDetailEntity>) {
    this.name = data?.name;
    this.code = data?.code;
    this.amount = data?.amount;
    this.status = data?.status;
    this.type = data?.type;
    this.description = data?.description;
    this.config = data?.config;
    this.order = data?.order;
    this.carrier = data?.carrier;
    this.AirTimeSupplier = data?.AirTimeSupplier;
  }

  removeUnknowValue?(data: AirtimeDetailEntity) {
    return DataFormat.removeUndefined(
      data as unknown as Record<string, unknown>,
    );
  }
}
